import { useDispatch, useSelector } from 'react-redux';
import { PaxCombination } from 'shared/search/prepackage/PaxCombination';
import type { PaleState, ThunkDispatchFunc } from '@/interfaces';
import { actions as filterActions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';

export const ResultPagePaxCombination = () => {
    const dispatch = useDispatch<ThunkDispatchFunc>();

    const numberOfAdults = useSelector((s: PaleState) => s.filters.numberOfAdults);
    const agesOfChildren = useSelector((s: PaleState) => s.filters.agesOfChildren);

    const updatePax = (adults: number, agesOfChildren: number[]) => {
        dispatch(filterActions.changePaxCombination({ numberOfAdults: adults, agesOfChildren: agesOfChildren }));
        setTimeout(() => {
            dispatch(fetchResults());
        }, 1000);
    };

    return (
        <PaxCombination
            numberOfAdults={numberOfAdults}
            agesOfChildren={agesOfChildren}
            label="Antall reisende"
            updatePax={updatePax}
            className="mt-16"
        />
    );
};
